module.exports = __webpack_public_path__ + "img/20.cfa57a24.png";